<template>
    <v-card cols="12" sm="6" class=" pa-5 mt-2" tile>
        <v-card-title>
            <v-icon color="grey darken-2">mdi-map-marker</v-icon>
            <div class="subtitle-1 font-weight-medium pl-2">Site Address:</div>
            <div class="subtitle-1 pl-2 font-weight-medium blue--text text--darken-2">
                {{ site.address }}
            </div>
            <v-spacer></v-spacer>
            <div class="subtitle-1 font-weight-medium ">Status:</div>
            <div class="subtitle-1 pr-2 pl-1">{{ siteStatus.text }}</div>
            <v-icon class="pr-2" :color="siteStatus.color" size="48">
                {{ siteStatus.icon }}
            </v-icon>

        </v-card-title>

        <v-layout row class=" ml-5 pb-5">

            <div class=" pl-5 ml-2 body-2  "  >
                {{ siteStatus.hint }}
            </div>
        </v-layout>

        <v-layout row class=" ml-5 mr-5">
            <v-progress-linear
                    :color="siteStatus.color"
                    height="6"
                    :value="siteStatus.length"
                    striped
            ></v-progress-linear>
        </v-layout>
        <!-- Snackbar -->
        <v-snackbar v-model="alert.message" top left :timeout="timeout">
            {{alert.type}}
        </v-snackbar>
    </v-card>
</template>
<style>

</style>
<script>
  import { router } from "../router";
  import Details from "./Details.vue";
  import Add from "./Add.vue";
  import { status } from "../helpers";

  export default {
    name: "Site",
    props: ["site"],
    components: {
      Details,
      Add
    },
    data: () => ({
      timeout: 6000,
      report: false,
      disabled: false,
      status: status,
      siteDialog: false,
      buildingDialog: false,
      mask: "####################",
      valid: false,
      changed: false,
      dateFrom: "",
      dateTo: "",
      menuFrom: false,
      menuTo: false,
      ctsnRules: [
        v => !!v || "CTSN is required"
        /*v => (v && v.length <= 20) || "CTSN must be less than 20 characters"*/
      ]
    }),
    computed:{
      alert (){
        return this.$store.state.alert
      },
      siteStatus (){
        return status[this.site.inspection_status.toString()]
      }
    },
    mounted() {
    },
    methods: {
      input: function() {
        this.changed = true;
      },
      validate() {
        if (this.$refs.form.validate()) {

          //this.submit();
        }
      },
      submit() {
        const site = this.site;
        this.$store.dispatch("sites/submit", { site } );
      },
      save() {
        //TODO put in conditions of success here

        const site = this.site;
        this.$store.dispatch("sites/saveSite", { site } );
      },
      deleteSite(){
        const siteId = this.site.id;
        this.$store.dispatch("sites/delete", { site: siteId} );
      }
    }
  };
</script>
